<template>
  <div class="table-warp">
    <el-table
      class="table-content"
      :class="border ? '' : 'table-no-border'"
      ref="table"
      :size="size"
      :row-key="rowkey"
      :data="data"
      :height="'500px'"
      :id="id"
      :cell-style="tableCellStyle"
      :highlight-current-row="rowselect"
      @current-change="rowselectChange"
      @row-dblclick="rowdblclick"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick"
      :span-method="arraySpanMethod"
      :stripe="stripe"
      :border="border"
      :show-summary="showSummary"
      :summary-method="getSummaries"
      tooltip-effect="light"
      :empty-text="emptyText"
    >
      <el-table-column
        v-if="selectColumnVisible"
        :selectColumnVisible="selectColumnVisible"
        type="selection"
      ></el-table-column>
      <template v-for="(item, index) in columns">
        <template v-if="item.show != false">
          <slot v-if="item.slot" :name="item.slot"></slot>
          <el-table-column
            v-else
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :align="item.align ? item.align : 'center'"
            :fixed="item.fixed ? item.fixed : false"
            :width="item.width"
            :formatter="item.formatter ? item.formatter : formatterValue"
            :type="item.type ? item.type : ''"
            :show-overflow-tooltip="true"
            :sortable="item.sortable ? item.sortable : false"
          >
          </el-table-column>
        </template>
      </template>
      <slot></slot>
    </el-table>
    <el-pagination
      v-if="showPage"
      class="pageNew"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.pageIndex ? page.pageIndex : 0"
      :page-sizes="page.pageSizes"
      :page-size="page.size"
      layout="total,  prev, pager, next,sizes"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    //是否显示分页
    showPage: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: String,
      default: "",
    },
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rowkey: {
      type: String,
      default: "",
    },
    rowselect: {
      type: Boolean,
      default: false,
    },
    stripe: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "medium",
    },
    selectColumnVisible: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Object,
      default: () => {
        return {
          pageSizes: [10, 20, 30, 40], //每页显示条目个数
          size: 10,
          total: 0,
          pageIndex: 0,
        };
      },
    },
    arraySpanMethod: {
      type: Function,
      default: () => {},
    },
    border: {
      type: Boolean,
      default: true,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.emptyText);
  },
  computed: {},
  methods: {
    // tableHeaderColor({ row, column, rowIndex, columnIndex }){
    //   //改表头颜色
    //   if (rowIndex === 0) {
    //     return "background-color: #F3F3F3;color: #666;";
    //   }
    // },
    //设置单元格样式
    tableCellStyle(row, column, rowIndex, columnIndex) {
      if (row.row.currentValue && row.columnIndex === 4) {
        if (
          row.row.compare == 1 &&
          parseFloat(row.row.currentValue) > parseFloat(row.row.desiredValue)
        ) {
          /* 当范围为大于 ，当前值大于预估值 */
          return "color:#8293b5";
        } else if (
          row.row.compare == 2 &&
          parseFloat(row.row.currentValue) < parseFloat(row.row.desiredValue)
        ) {
          /* 当范围为小于 ，当前值小于预估值 */
          return "color:#8293b5";
        } else if (row.row.currentValue == "-") {
          return "color:#8293b5";
        } else {
          return "color:#FE7B80";
        }
      }
    },
    //单选时
    rowselectChange(val) {
      this.$emit("rowselectChange", val);
    },
    rowdblclick(val) {
      this.$emit("rowdblclick", val);
      //   console.log(val);
    },
    // 当某一行被点击时会触发该事件
    handleRowClick(val) {
      this.$emit("handleRowClick", val);
    },
    // 当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    //改变页面大小处理
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    //上下一页
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    formatterValue(row, column, cellValue) {
      return cellValue;
    },
    setCurrentRow(row) {
      this.$nextTick(() => {
        this.$refs.table.setCurrentRow(row);
      });
    },
    selection() {
      //获取checkbox选中的行数据
      return this.$refs.table.selection;
    },
    // tableHeaderColor({ row, column, rowIndex, columnIndex }) {
    //   //改表头颜色
    //   if (rowIndex === 0) {
    //     return "background-color: #dbdbdb;color: #666;";
    //   }
    // },
    getSummaries(param) {
      //合计行
      this.$emit("summaryMethod", param);
    },
  },
  watch: {
    rowkey() {
      console.log(this.rowkey);
    },
    data() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
<style lang="scss">
.configurationTable .el-table__body-wrapper {
  overflow: hidden;
}
.afterRenderClass {
  .el-table__body-wrapper {
    overflow: auto;
  }
}
.el-table__empty-text {
  font-size: 26px;
}
.table-no-border {
  td {
    border-right: 0px;
  }
}
</style>
<style scoped>
.table-warp {
  width: 100%;
  height: 100%;
  min-height: 100px;
  display: flex;
  flex: 1;
  flex-flow: column;
}
.table-content {
  flex: 1;
  overflow-x: auto;
}
.pageNew {
  text-align: right;
  padding: 14px 0px;
}
.table-warp >>> .el-table .cell.el-tooltip {
  white-space: nowrap;
  min-width: 50px !important;
  max-width: 100%;
}

.pageNew >>> .active {
  background: #0080ff;
  background-color: #0080ff !important;
}
</style>
